import { UiLabelsProvider } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';
import { useEffect, useMemo } from 'react';

import { useDictionary, useLocale } from '@/core/providers/dictionary-provider';

/**
 * Feeds the shared components their translated labels and keeps
 * `<html lang>` on the active locale, so screen readers and hyphenation use
 * the app language (DEV-537).
 */
export function AppUiLabelsProvider({ children }: { children: ReactNode }) {
  const dict = useDictionary();
  const locale = useLocale();

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  const labels = useMemo(
    () => ({
      close: dict.ui.close,
      loading: dict.ui.loading,
      notifications: dict.ui.notifications,
      toggleSidebar: dict.sidebar.toggleSidebar,
      previousPage: dict.ui.previousPage,
      nextPage: dict.ui.nextPage,
      previous: dict.ui.previous,
      next: dict.ui.next,
      morePages: dict.ui.morePages,
      previousSlide: dict.ui.previousSlide,
      nextSlide: dict.ui.nextSlide,
    }),
    [dict.sidebar.toggleSidebar, dict.ui],
  );

  return <UiLabelsProvider labels={labels}>{children}</UiLabelsProvider>;
}
